import navEn from "../locales/en/nav.json";
import homeEn from "../locales/en/home.json";
import blogEn from "../locales/en/blog.json";
import hobbyEn from "../locales/en/hobby.json";
import communityEn from "../locales/en/community.json";
import contactEn from "../locales/en/contact.json";
import modalEn from "../locales/en/modal.json";

import navTr from "../locales/tr/nav.json";
import homeTr from "../locales/tr/home.json";
import blogTr from "../locales/tr/blog.json";
import hobbyTr from "../locales/tr/hobby.json";
import communityTr from "../locales/tr/community.json";
import contactTr from "../locales/tr/contact.json";
import modalTr from "../locales/tr/modal.json";

export type Language = "en" | "tr";

export const translations = {
  en: {
    nav: navEn,
    home: homeEn,
    blog: blogEn,
    hobby: hobbyEn,
    community: communityEn,
    contact: contactEn,
    modal: modalEn
  },
  tr: {
    nav: navTr,
    home: homeTr,
    blog: blogTr,
    hobby: hobbyTr,
    community: communityTr,
    contact: contactTr,
    modal: modalTr
  }
};

export function detectLanguage(): Language {
  if (typeof navigator !== "undefined" && navigator.language) {
    const lang = navigator.language.toLowerCase();
    if (lang.startsWith("tr")) {
      return "tr";
    }
  }
  return "en";
}

/**
 * Safely retrieves page translation object for a language code without bracket notation.
 */
export function getPageTranslations(lang: string) {
  if (lang === "tr") {
    return translations.tr;
  }
  return translations.en;
}

/**
 * Safely resolves localized fields (e.g. { en: "...", tr: "..." }) without bracket notation.
 */
export function getTranslation<T>(
  obj: { en: T; tr: T; it?: T; de?: T; es?: T; fr?: T } | T | undefined,
  lang: string
): T {
  if (obj === undefined || obj === null) {
    return "" as unknown as T;
  }
  if (typeof obj !== "object") {
    return obj as T;
  }
  const typedObj = obj as { en: T; tr: T; it?: T; de?: T; es?: T; fr?: T };
  if (lang === "tr" && typedObj.tr !== undefined) {
    return typedObj.tr;
  }
  if (lang === "it" && typedObj.it !== undefined) {
    return typedObj.it;
  }
  if (lang === "de" && typedObj.de !== undefined) {
    return typedObj.de;
  }
  if (lang === "es" && typedObj.es !== undefined) {
    return typedObj.es;
  }
  if (lang === "fr" && typedObj.fr !== undefined) {
    return typedObj.fr;
  }
  return typedObj.en !== undefined ? typedObj.en : (obj as unknown as T);
}
